import CertificateTypes from 'todistukset-common/src/vtj/CertificateTypes.enum'

/* FIXME this duplicates information from certificate.utils.ts in todistukset-common package */
const attributeToCertificateTypesMap: Record<string, CertificateTypes[]> = {
  includePreviousNames: [
    CertificateTypes.ASUINPAIKKATODISTUS,
    CertificateTypes.AVIOLIITTOTODISTUS,
    CertificateTypes.ELOSSAOLOTODISTUS,
  ],
  includePreviousPermanentAddresses: [CertificateTypes.ASUINPAIKKATODISTUS],
  includeMaritalStatus: [CertificateTypes.ASUINPAIKKATODISTUS],
  includeSpousePreviousNames: [CertificateTypes.AVIOLIITTOTODISTUS],
  includePreviousMarriages: [CertificateTypes.AVIOLIITTOTODISTUS],
}
export const showInformationForCertificateType = (
  attrName: string,
  certificateType: CertificateTypes
): boolean => {
  const allowedCertificates = attributeToCertificateTypesMap[attrName]

  // If no restrictions have been defined, return true
  if (!allowedCertificates) {
    return true
  }

  return !!allowedCertificates.find(
    (allowedCertificate) => certificateType === allowedCertificate
  )
}
